const billItemTypes: object = {
  sales: 'sales',
  non_sales: 'non_sales'
};

function options(): any[] {
  return Object.entries(billItemTypes).map(([key, value]) => (
    { value, label: key })
  );
}

export default options;
